import * as _ from "lodash";
import moment from "moment-timezone";

interface ComponentDates {
  component?: JSX.Element;
  date: Date;
}
export const isMonthDisabled = (month: number, fromMonth: Date, toMonth: Date) => {
  const thisMonth = new Date(month);

  if (thisMonth > toMonth || thisMonth < fromMonth) {
    return false;
  }

  return true;
};

export const isDayValid = (day: Date, fromDate?: Date, disabledDates?: ComponentDates[], disabledDays?: number[]) => {
  const today = new Date();

  // Cannot order for the past
  if (moment.utc(day).format("YYYY-MM-DD") < moment.utc(today).format("YYYY-MM-DD")) {
    return false;
  }

  // Cannot order fromDate
  if (fromDate && day < fromDate) {
    return false;
  }

  // Cannot order if day is disabled
  if (disabledDates && isDisabled(day, disabledDates)) {
    return false;
  }

  // Cannot order if delivery_day is disabled for drop
  if (disabledDays && _.includes(disabledDays, day.getDay())) {
    return false;
  }

  return true;
};

export const isWarning = (day: Date, warningDates: ComponentDates[]) => {
  return warningDates.some(warningDate => isSameDay(warningDate.date, day));
};

// TODO: This function looks to do almost the same, refactor them into one!

/**
 * Check if a day is disabled for ordering.
 *
 * Basically, checks if the passed date is one of the list
 * of disabled dates.
 *
 * @param day - date to check.
 * @param datesList - list of disabled dates.
 *
 * @return - TRUE if the date is disabled.
 */
export const isDisabled = (day: Date, datesList?: ComponentDates[]) => {
  if (datesList) {
    return datesList.some(date => isSameDay(date.date, day));
  }

  return false;
};

/**
 * Check if a day is disabled for ordering and the reason for it .
 *
 * Basically, checks if the passed date is one of the list
 * of disabled dates.
 *
 * @param day - date to check.
 * @param datesList - list of disabled dates.
 *
 * @return - the reason if the date is disabled.
 */
export const isDisabledReason = (day: Date, datesList?: ComponentDates[]) => {
  if (datesList) {
    const found = datesList.find(dateReason => isSameDay(dateReason.date, day));

    return found ? found.component : null;
  }

  return null;
};

/**
 * Check if a day has already orders.
 *
 * Basically, checks if the passed date is one of the list
 * of dates with orders.
 *
 * @param day - date to check.
 * @param datesList - list of dates with order.
 *
 * @return - TRUE if the date has orders.
 */
export const hasOrders = (day: Date, datesList?: Array<{ id: number; date: Date }>) => {
  if (datesList) {
    return datesList.some(dateOrder => isSameDay(dateOrder.date, day));
  }

  return false;
};

/**
 * Check if two dates are the same day, no matter of the time.
 *
 * Example:
 *  - "01-01-2019 12:00:00" is same day as "01-01-2019 00:00:00"
 *  - "01-01-2019 23:59:59" is not same day as "02-01-2019 00:00:00"
 *
 * @param day1
 * @param day2
 */
export const isSameDay = (day1: Date, day2: Date) => {
  return moment.utc(day1).format("YYYY-MM-DD") === moment.utc(day2).format("YYYY-MM-DD");
};

export const isWholeWeekInMonth = (startOfWeek: Date, month: Date) => {
  const endOfWeek = moment
    .utc(startOfWeek)
    .endOf("week")
    .toDate();

  if (startOfWeek.getFullYear() !== month.getFullYear()) {
    return false;
  }

  if (endOfWeek.getFullYear() !== month.getFullYear()) {
    return false;
  }

  return startOfWeek.getMonth() === month.getMonth() && endOfWeek.getMonth() === month.getMonth();
};

export const getLocalTimeZoneAbbrev = () => {
  const timeZone = moment.tz.guess();
  const time = new Date();
  const timeZoneOffset = time.getTimezoneOffset();
  const timeZoneLong = moment.tz.zone(timeZone);

  return timeZoneLong ? timeZoneLong.abbr(timeZoneOffset) : "";
};

export const getLocalTimeZone = () => {
  const timeZone = moment.tz.guess();
  const zone = moment.tz.zone(timeZone);

  return zone;
};
